import React from "react"
import {
  autresActualites,
  actualiteContainerFirst,
  actualiteContainer,
  editButtonFirstActu,
} from "../actualites.module.scss"
import ActuItem from "../ActuItem/actu-item"
import PropTypes from "prop-types"
import TransitionFade from "../../../transition-fade"
import EditButton from "../../../EditButton/edit-button"

const RenderActualites = ({ actualiteData }) => {
  const actus = actualiteData.slice(0, 4)

  const firstActu = actus[0].node
  return (
    <>
      <EditButton
        addedClass={editButtonFirstActu}
        link={"/node/" + firstActu.drupal_internal__nid + "/edit"}
      />
      <TransitionFade link={firstActu.path.alias}>
        <ActuItem myClassName={actualiteContainerFirst} actu={firstActu} />
      </TransitionFade>
      <ul className={autresActualites}>
        {actus.slice(1).map(({ node }) => {
          return (
            <li key={node.drupal_id}>
              <EditButton
                link={"/node/" + node.drupal_internal__nid + "/edit"}
              />
              <ActuItem myClassName={actualiteContainer} actu={node} />
            </li>
          )
        })}
        <div>
          <TransitionFade className="btn" link="/actualites">
            Toutes nos actualités
          </TransitionFade>
        </div>
      </ul>
    </>
  )
}

RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

export default RenderActualites
